import api from "../../../shared/services/api";
import { toast } from "react-toastify";

export default async function loadDataService(start, end) {
  try {
    const params = {};
    if (start) params.start = start;
    if (end) params.end = end;
    const response = await api.get("/vendas/mes", { params });
    return response;
  } catch (err) {
    toast.error("Erro ao carregar dados do mês");
    return null;
  }
};